module.exports = __webpack_public_path__ + "static/media/08GalleryPuppets.488e044b.jpeg";